module.exports = __webpack_public_path__ + "img/douyincx.eba51b33.jpg";